// CATEGORY MODULE FOR LOANS / TRANSACTIONS / IMPORT

import dayjs from 'dayjs';
import { postFileImportData } from '../../../redux/reducers/data';

const utc = require('dayjs/plugin/utc');

dayjs.extend(utc);

// INPUT transformations

// used to put quote object attributes in the exact order expected by the GRID layout (and the gridLayout.js file which defines the columns in the spreadsheet)
// TABLE will use the same object, but the sequence does not matter (sequence is set in tableLayout.js file)
export function categoryOrderedObject(account = null, displayedComponent = 'table') {
  //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
  return function loansOrdereObjectInnerFunc(transaction) {
    // this has to exactly follow the column order laid out by gridLayout
    return {
      keepFlag: transaction.keepFlag || null,
      source: transaction.source,
      date: displayedComponent === 'table' ? Number(transaction.date) : dayjs.utc(Number(transaction.date)).format(), // table expects a number, grid expects a string
      otherPartyIban: transaction.otherPartyIban,
      description: transaction.description,
      quantity: transaction.quantity,
      quantityInterest: transaction.quantityInterest,
      fxCurrency: transaction.transactionCurrency && transaction.uptc ? transaction.transactionCurrency : null,
      fxAmount: transaction.transactionCurrency && transaction.uptc ? transaction.quantity * transaction.uptc : null,
      fxAmountInterest: transaction.transactionCurrency && transaction.uptc ? transaction.quantityInterest * transaction.uptc : null,
      fxRate: transaction.transactionCurrency && transaction.uptc ? transaction.uptc : null,
      id: transaction.id,
      accountCurrency: transaction.accountCurrency,
    };
  };
}

// OUTPUT transformations

// used inside of .map
// performs category-specific transformations after standard transformations of Grid output
// seqeunce of properties is no longer important
// this happens already after items with inputFlag = 'delete' have been added, so just take care of 'put'

export function outputTransformCategoryTransactions(account = null) {
  //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
  return function outputTransformCategoryTransactionsInnerFunc(item) {
    return item;
  };
}

// Grid handles dispatch and its result; this is just the action creator for post transactions
export function postCategoryItems(data, account) {
  return postFileImportData({ data, category: 'loans', accountId: account.id });
}

// OTHERS

// used in markDuplicateTransaction to decide if two transactions are duplicated
// if changing / adding fields here, also modify the accountDataSelector below
export function checkIfDuplicate(transaction1, transaction2) {
  return (
    transaction1.source !== transaction2.source // we are checking if imported transactions are already present in the account, we allow duplicates within one source ('app' or 'import')
    && transaction1.date === transaction2.date
    && transaction1.quantity === transaction2.quantity
    && transaction1.quantityInterest === transaction2.quantityInterest
  );
}
